/*
 * Contact フォームの入力保持。
 * Shopify の contact フォームは標準項目（email/body）しか送信失敗時に再表示しないため、
 * 日本語キーのカスタム項目（お名前/フリガナ/法人名/URL/電話番号）は検証エラーで再描画されると消える。
 * これを防ぐため、入力値を sessionStorage に退避し、エラー再表示時に空のフィールドへ復元する。
 * 成功時は退避をクリア。値はユーザー自身の入力（同一オリジン・タブ内の一時保存）で、.value への代入のみ＝XSS 面なし。
 * markup は sections/contact-form.liquid。
 */
(function () {
  var KEY = 'kunisawa:contact-form';
  var container = document.querySelector('.contact__form-col');
  if (!container) return;

  // 送信成功 → 退避をクリアして終了（古い入力を残さない）
  if (container.querySelector('.contact-form__success')) {
    try {
      sessionStorage.removeItem(KEY);
    } catch (e) {
      /* sessionStorage 不可（プライベートブラウズ等）は無視 */
    }
    return;
  }

  var form = container.querySelector('.contact-form');
  if (!form) return;

  // 退避/復元の対象＝contact[...] の入力（チェックボックス・hidden は除く＝同意状態や form_type は保存しない）
  function persistableFields() {
    return Array.prototype.filter.call(
      form.querySelectorAll('input[name^="contact["], textarea[name^="contact["]'),
      function (el) {
        return el.type !== 'checkbox' && el.type !== 'hidden';
      }
    );
  }

  var fields = persistableFields();

  // 検証エラーで再描画された → 退避値を「空のフィールドだけ」へ復元
  // （email/body はサーバ側で再表示済みなので上書きしない）
  if (container.querySelector('.contact-form__errors')) {
    try {
      var saved = JSON.parse(sessionStorage.getItem(KEY) || '{}');
      fields.forEach(function (el) {
        if (!el.value && typeof saved[el.name] === 'string') {
          el.value = saved[el.name];
        }
      });
    } catch (e) {
      /* 壊れた退避は無視 */
    }
  }

  // 入力のたびに退避（送信前にブラウザへ保持）
  form.addEventListener('input', function () {
    var data = {};
    persistableFields().forEach(function (el) {
      data[el.name] = el.value;
    });
    try {
      sessionStorage.setItem(KEY, JSON.stringify(data));
    } catch (e) {
      /* 容量超過・不可は無視 */
    }
  });
})();
